<template>
    <Form @submit="saveLaboratory" :key="createMode">
        <div class="laboratory-form flex flex-column overflow-hidden gap-3">
            <CustomInputNumber name="id" label="ID" v-model="editedLaboratory.id" class="w-10" rules disabled
                               noPlaceholder />
            <CustomInputText name="name" label="Name" v-model="editedLaboratory.name" class="w-10"
                             required noPlaceholder
                             :customErrorMessage="getRequiredMessage(editedLaboratory.name)" />
            <div class="laboratory-buttons flex align-self-center gap-4 mt-6">
                <CustomButton label="Save" type="submit" />
                <CustomButton v-if="createMode" label="Cancel" secondary
                              @click="hideForm" />
                <CustomButton v-else label="Delete" secondary
                              @click="deleteLaboratory" />
            </div>
        </div>
    </Form>
</template>

<script>
import {Form} from "vee-validate";
import {
    createOrUpdateLaboratory,
    deleteLaboratory,
} from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { ValidateUtils } from "@/utils/ValidateUtils";

export default {
    name: "LaboratoryForm",

    components: {
        CustomInputText,
        Form,
        CustomInputNumber,
        CustomButton,
    },

    props: {
        selectedLaboratory: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            editedLaboratory: {
                id: null,
                name: "",
            },
            createMode: true,
            showErrorMessages: false,
        };
    },

    emits: ["change-element", "createMode", "hideForm"],

    mounted() {
        this.$emit("createMode", this.createMode);
    },

    methods: {
        validateData() {
            let isCorrect = ValidateUtils.validateNotEmpty(this.editedLaboratory, ["name"]);
            this.showErrorMessages = !isCorrect;
            return isCorrect;
        },
        getRequiredMessage(value) {
            if (this.showErrorMessages && (value === null || value === "")) {
                return this.$t("message.validations.required");
            }
            return "";
        },
        notifyChange() {
            this.$emit("change-element");
            this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Data saved",
                life: 3000,
            });
        },
        notifyDelete() {
            this.$emit("change-element");
            this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Element deleted",
                life: 3000,
            });
        },
        notifyError(error) {
            const message = error.response?.data?.message || "Something went wrong";
            this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: message,
                life: 5000,
            });
        },
        saveLaboratory() {
            if (this.validateData()) {
                createOrUpdateLaboratory({body: this.editedLaboratory})
                    .then(() => {
                        this.notifyChange();
                    })
                    .catch((error) => {
                        this.notifyError(error);
                    });
            }
        },
        deleteLaboratory() {
            deleteLaboratory({id: this.editedLaboratory.id})
                .then(() => {
                    this.notifyDelete();
                    this.showErrorMessages = false;
                })
                .catch((error) => {
                    this.notifyError(error);
                });
        },
        hideForm() {
            this.$emit("hideForm");
        },
    },

    watch: {
        selectedLaboratory(newValue) {
            this.editedLaboratory = _.cloneDeep(newValue);
            this.createMode = newValue.id === null || newValue.id === undefined || isNaN(newValue.id);
            this.$emit("createMode", this.createMode);
        },
    },
};
</script>

<style lang="less">
.laboratory-form {
    .custom-input-text, .custom-input-number, .custom-select-one {
        padding-left: 170px;
        .custom-label {
            text-align: right;
            z-index: 999;
            position: absolute;
            transform: translateX(-100%);
            left: 160px;
        }
    }
    @media screen and (max-width: 650px) {
        align-items: end;
        .custom-input-text, .custom-input-number, .custom-select-one {
            padding-left: 40px;
            .custom-label {
                left: 30px;
            }
        }
    }
}
</style>
